import i18n from 'i18next';

import {apiClient} from 'core/apiClient';

const BRANDS_URL = '/service/product-cards/api/v2/service/product-cards/trademark';
const PRODUCT_GROUPS_URL = '/service/product-groups';

export async function fetchBrands() {
    return (
        await apiClient.get(BRANDS_URL, {
            baseURL: '/api/v2',
            headers: {'Customer-Language': i18n.language},
        })
    ).data;
}

export async function fetchProductGroups() {
    return (
        await apiClient.get(PRODUCT_GROUPS_URL, {
            baseURL: '/api/v1',
            headers: {'Customer-Language': i18n.language},
        })
    ).data;
}
